import { ProjectDataDisplayModelFormGroup } from './../../../../../api/models/ace/xFound/Portal/Core/CAQ/Models/project-data-display-model';
import { Component, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { DialogService } from '@progress/kendo-angular-dialog';
import { NgxSpinnerService } from 'ngx-spinner';
import { LoadingAnimationService } from '@/core/services/loading-animation.service';
import { StateService } from '@/core/services/state.service';
import { AnfrageService } from '@/api/service-index';
import { ProjectDataDisplayModel } from '@/api/models/ace/xFound/Portal/Core/CAQ/Models/project-data-display-model';
import { SectionService } from '@/core/services/section.service';
import { PortalContextService } from '@/core/services/portal-context.service';
import { AnfrageNavigationFormComponent, MoveDirection } from '../../../../components/anfrage-navigation-form/anfrage-navigation-form.component';
import { UnfinishedHttpMethodsService } from '@/core/services/unfinished-http-methods.service';
import { convertJSDateString } from '@/core/utils/date-converter';

@Component({
    selector: 'project-data-process-step',
    templateUrl: './project-data-process-step.component.html',
    styleUrls: ['./project-data-process-step.component.scss'],
    standalone: false
})
export class ProjectDataProcessStepComponent extends AnfrageNavigationFormComponent implements OnInit {

  public projectDataProcessStepForm: ProjectDataDisplayModelFormGroup;
  public projectData: ProjectDataDisplayModel;
  protected canceledRoute: string;

  public get formGroup(): FormGroup<any> {
    return this.projectDataProcessStepForm;
  }
  
  constructor(protected sectionService: SectionService,
    protected route: ActivatedRoute,
    protected loadingAnimationService: LoadingAnimationService,
    protected router: Router,
    protected anfrageService: AnfrageService,
    protected dialogService: DialogService,
    protected spinnerService: NgxSpinnerService,
    protected stateService: StateService,
    protected portalContextService: PortalContextService,
    protected unfinishedHttpMethodsService: UnfinishedHttpMethodsService) {

    super(sectionService, router, route, portalContextService);

    this.projectData = this.route.snapshot.data.projectData;
  }

  ngOnInit(): void {
    this.projectDataProcessStepForm = ProjectDataDisplayModelFormGroup.Instance;
    
    super.ngOnInit();

    this.projectDataProcessStepForm.patchValue(this.projectData);

    if (this.projectData.projektStart)
      this.projectDataProcessStepForm.ProjektStart.setValue(new Date(this.projectData.projektStart))

    if (this.projectData.projektEnd)
      this.projectDataProcessStepForm.ProjektEnd.setValue(new Date(this.projectData.projektEnd))

    if (this.stateService.IsEndvalidationEnabled)
      this.projectDataProcessStepForm.updateValueAndValidity();
  }

  protected save(shouldSave: boolean, moveDirection: MoveDirection): void {
    let projectData: ProjectDataDisplayModel = this.projectDataProcessStepForm.value;

    if (projectData && shouldSave && this.projectDataProcessStepForm.dirty) {
      projectData.projektStart = convertJSDateString(projectData.projektStart);
      projectData.projektEnd = convertJSDateString(projectData.projektEnd);

      delete this.portalContextService.CurrentAnfrage.projectData;
      this.projectDataProcessStepForm.markAsPristine();
      if (moveDirection != MoveDirection.STAY) {
        if (this.canceledRoute) {
          this.router.navigateByUrl(this.canceledRoute);
        } else {
          this.move(moveDirection);
        }
      }

      let subscription = this.anfrageService.apiAnfrageAnfrageIdProjectDataPatch({ anfrageId: this.anfrage.id, body: projectData })
        .subscribe(() => {
          this.anfrageService.apiAnfrageAnfrageIdValidateGet({ anfrageId: this.anfrage.id }).subscribe(result => {
            this.stateService.ValidationErrors = result;
          })

          if (this.portalContextService.CurrentAnfrage) {
            this.portalContextService.CurrentAnfrage.projectData = projectData;
            this.portalContextService.CurrentAnfrage.name = projectData.title;
          }
            

          var projekt = this.portalContextService.Anfragen?.find(a => a.id == this.anfrage.id);
          if (projekt && this.anfrage.projectData?.title)
            projekt.name = this.anfrage.projectData.title;

          this.projectDataProcessStepForm.markAsPristine();
        }, (error) => {
          this.projectDataProcessStepForm.markAsDirty();
          throw error;
        });

      this.loadingAnimationService.showSpinnerUsingSubscription(subscription);
      this.unfinishedHttpMethodsService.addSubscription(subscription);
    } else {
      this.projectDataProcessStepForm.markAsPristine();
      this.move(moveDirection);
    }
  }
}
